
import React, { useState, useEffect } from 'react';
import '../styles/ValidationResults.css';
const API_BASE = import.meta.env.VITE_API_BASE;

function ValidationResults({ jobId }) {
  const [validation, setValidation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    const fetchValidation = async () => {
      try {
        const response = await fetch(`${API_BASE}/validate/${jobId}`);
        if (!response.ok) {
          const text = await response.text();
          setError(`API error: ${response.status} - ${text}`);
          setValidation(null);
          return;
        }
        const data = await response.json();
        setValidation(data);
      } catch (err) {
        console.error('Error fetching validation:', err);
        setError('Could not reach server');
        setValidation(null);
      }
      setLoading(false);
    };

    if (jobId) fetchValidation();
    else setLoading(false);
  }, [jobId]);

  if (loading) {
    return <div className="validation">Loading validation results...</div>;
  }

  if (error) {
    return <div className="validation"><p className="validation-error">Error: {error}</p></div>;
  }

  if (!validation) {
    return <div className="validation">Validation results not available yet</div>;
  }

  const checkItems = validation.checks || {};
  const totalErrors = Object.values(checkItems).reduce((sum, c) => sum + (c.errors?.length || 0), 0);

  return (
    <div className="validation">
      <h2>Validation Results</h2>

      <div className={`validation-status ${validation.valid ? 'valid' : 'invalid'}`}>
        <h3>{validation.valid ? '✓ All Checks Passed' : `✗ Validation Failed (${totalErrors} error${totalErrors !== 1 ? 's' : ''})`}</h3>
        {validation.message && <p className="validation-message">{validation.message}</p>}
      </div>

      <div className="checks-grid">
        {Object.entries(checkItems).map(([checkName, checkResult]) => (
          <div key={checkName} className={`check-card ${checkResult.passed ? 'passed' : 'failed'}`}>
            <h4>{checkName.replace(/_/g, ' ').toUpperCase()}</h4>
            <div className="check-status">
              <span className="badge">{checkResult.passed ? '✓ PASSED' : '✗ FAILED'}</span>
              {checkResult.errors?.length > 0 && (
                <span className="error-count">{checkResult.errors.length} error{checkResult.errors.length !== 1 ? 's' : ''}</span>
              )}
            </div>
            
            {checkResult.errors?.length > 0 && (
              <div className="errors">
                <strong>Errors:</strong>
                <ul>
                  {checkResult.errors.slice(0, 20).map((err, i) => (
                    <li key={i}>{err}</li>
                  ))}
                </ul>
                {checkResult.errors.length > 20 && (
                  <p className="more-errors">... and {checkResult.errors.length - 20} more</p>
                )}
              </div>
            )}

            {checkResult.details && (
              <div className="info">
                <strong>Record Counts:</strong>
                <table className="record-count-table">
                  <thead>
                    <tr><th>Entity</th><th>Expected</th><th>Actual</th></tr>
                  </thead>
                  <tbody>
                    {Object.entries(checkResult.details).map(([entity, counts]) => (
                      <tr key={entity} className={counts.expected !== counts.actual ? 'mismatch' : ''}>
                        <td>{entity}</td>
                        <td>{counts.expected}</td>
                        <td>{counts.actual}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ValidationResults;
